module.exports = __webpack_public_path__ + "static/logo-4504a8e9ad55cb65ed76ace25ea88bf7.jpg";